import { getBodyShapeIdByTitle } from '@/pages/Onboarding/options/BodyShape/utils/getBodyShapeIdByTitle';
import { getBreastSizeIdByTitle } from '@/pages/Onboarding/options/BreastSize/utils/getBreastSizeIdByTitle';
import { getButtSizeIdByTitle } from '@/pages/Onboarding/options/ButtSize/utils/getButtSizeIdByTitle';

import { COMMUNUCATE_OPTIONS } from '../../OwnAI/screens/Communicate/constants';
import { layoutDataDefault } from '../constants';
import { LayoutDataType } from '../types';

type LayoutDataTypeFromUser = {
  body_shape: string;
  breast_size: string;
  butt_size: string;
  communicate: string;
  personality?: {
    shy_dominant: number;
    serious_flirty: number;
    logical_emotional: number;
    affectionate_independent: number;
  };
  name?: string;
  send_photos?: boolean | null;
};

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataTypeFromUser,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    body_shape: getBodyShapeIdByTitle(onb_data.body_shape),
    breast_size: getBreastSizeIdByTitle(onb_data.breast_size),
    butt_size: getButtSizeIdByTitle(onb_data.butt_size),
    communicate:
      COMMUNUCATE_OPTIONS.find(
        (option) => option.title === onb_data.communicate,
      )?.id ?? null,
    personality: onb_data.personality || layoutDataDefault.personality,
    name: onb_data.name || layoutDataDefault.name,
    send_photos: onb_data.send_photos || layoutDataDefault.send_photos,
  };
};
